//hotpoints //elementy hover nia mają mieć satystyk ga360  //click mają mieć

"use strict";

window.dataLayer = window.dataLayer || [];

var galleriesHover = $(".hotpoints").each(function () { //(do statystyk na unload)
    //sprawdzamy, czy jest ustawiony id dla statystyk 
    var ga360id = $(this).data('ga360-id');
    var $artID = $(this).parents('.__js_stats_wrapper').data('id');
    if (ga360id == undefined) {
        console.log('%c dodać ga360-id do hotpointa: ' + $(this).data('id'), 'background: #553311; padding: 3px; color: #ffaaaa');
    } else {
        statElementCollector[ga360id + '-' + $artID] = {
            id: ga360id,
            moduleName: $(this).data('id'),
            viewedCount: 0,
            itemCount: $(this).find('.hotpoints--poi').length
        };
    };
    $(this).statVievedSlide = [];
    //pozycje

    slidePositionVieved[ga360id + '-' + $artID] = {}; //restet
});

$('.hotpoints--poi').on("click", function () {
    if (isScrolling) return;
    $('.hotpoints--poi, .hotpoints--poi-txt').removeClass('hover');

    $(this)
        .addClass('hover')
        .find('.hotpoints--poi-txt')
        .addClass('hover');
    $(this)
        .parent()
        .find('.hotpoints--desc-mobile .hotpoints--poi-txt')
        .eq($(this).index())
        .addClass('hover');

    /* staty */
    var $artID = $(this).parents('.__js_stats_wrapper').data('id'),
        $galID = $(this).parents('.hotpoints').data('id'),
        active = $(this).index(),
        ga360id = $(this).parents('.hotpoints').data('ga360-id');
    if (!ga360id) {
        console.log('%c dodać ga360-id do hotpointa!' + $galID + 'background: #3b3b3b; padding: 3px; color: #beeb2f');
    }
    var activeItem = $(this).index();
    //console.log('art:' + $artID + 'gal:' + $galID + ' / img: ' + $imgID);
    slidePositionVieved[ga360id + '-' + $artID][activeItem] = 1;
    statElementCollector[ga360id + '-' + $artID]['viewedCount'] = Object.keys(slidePositionVieved[ga360id + '-' + $artID]).length;

    sendStats('gallery', 'hotpoins', $artID + ' / ' + $galID, active);

    if (!isScrolligFlag) {
        dataLayer.push({
            event: 'content_interaction',
            eventCategory: ga360id,
            moduleName: $galID,
            eventAction: deviceTouch ? 'tap' : 'click'
        });
    }
    /* staty */

});

$('.hotpoints--close').on("click", function (e) {
    e.stopPropagation();
    $('.hotpoints--poi, .hotpoints--poi-txt').removeClass('hover');
});

// staty na pin - link cdc

$('.hotpoints--poi-txt a, .hotpoints--desc-mobile .hotpoints--poi-txt a').on("click", function (e) {
    // e.preventDefault();
    e.stopPropagation();

    /* staty */
    var $artID = $(this).closest('.__js_stats_wrapper').data('id'),
        $galID = $(this).closest('.hotpoints').data('id'),
        datalink = $(this).closest('.hotpoints--poi').data('link') || $(this).closest('.hotpoints--poi-txt').data('link');
    if (!datalink) {
        console.log('%c dodać data-link do hotpointa!' + $galID, 'background: #3b3b3b; padding: 3px; color: #beeb2f');
    }
    var activeItem = $(this).closest('.hotpoints--poi').index();

    //console.log('art:' + $artID + 'gal:' + $galID + ' / img: ' + $imgID);
    slidePositionVieved[datalink + '-' + $artID] = slidePositionVieved[datalink + '-' + $artID] || {}; // Initialize if undefined
    slidePositionVieved[datalink + '-' + $artID][activeItem] = 1;

    statElementCollector[datalink + '-' + $artID] = statElementCollector[datalink + '-' + $artID] || {};
    statElementCollector[datalink + '-' + $artID]['viewedCount'] = Object.keys(slidePositionVieved[datalink + '-' + $artID]).length;

    sendStats('gallery', 'hotpoints', $artID + ' / ' + $galID, activeItem);

    if (!isScrolligFlag) {
        dataLayer.push({
            event: 'content_interaction',
            eventCategory: datalink,
            moduleName: $galID,
            eventAction: deviceTouch ? 'tap' : 'click'
        });
    }
});
